import { selfInstantiateOnLoad } from "../utils";
export default class ManufacturerSpecials {
    constructor() {
        this._activeFilter = null;
        this._isFirstFilter = true;
        this.addEventListeners = () => {
            const filters = document.querySelectorAll("[data-filter]");
            for (const filter of filters) {
                filter.addEventListener("click", () => {
                    if (this._isFirstFilter) {
                        // Both mobile and desktop "all" filters are active
                        const allFilters = document.querySelectorAll("[data-filter].active");
                        for (const f of allFilters) {
                            f.classList.remove("active");
                        }
                    }
                    else if (filter === this._activeFilter) {
                        return;
                    }
                    else if (this._activeFilter) {
                        this._activeFilter.classList.remove("active");
                    }
                    filter.classList.add("active");
                    this._activeFilter = filter;
                    this.filterThumbs();
                });
            }
        };
        this.filterThumbs = () => {
            if (!this._activeFilter) {
                return;
            }
            const type = this._activeFilter.getAttribute("data-filter-type");
            const value = this._activeFilter.getAttribute("data-filter");
            switch (type) {
                case "all":
                    this.showAllThumbs();
                    break;
                case "yearmake":
                    this.filterThumbsByYearMake(value);
                    break;
                case "model":
                    this.filterThumbsByModel(value);
                    break;
            }
            this._vehicleTitle.textContent =
                type === "all"
                    ? this._vehicleTitle.getAttribute("data-all-text")
                    : this._activeFilter.textContent;
            if (this._isFirstFilter) {
                this.showThumbsSection();
                this._isFirstFilter = false;
            }
            window.scrollTo({ top: 0, behavior: "smooth" });
        };
        this.filterThumbsByYearMake = (filter) => {
            const [year, make] = filter.split("|");
            for (const thumb of this._thumbs) {
                if (thumb.getAttribute("data-year") === year &&
                    thumb.getAttribute("data-make") === make) {
                    thumb.removeAttribute("hidden");
                    // When filtered down to a year-make, we don't show the year
                    thumb.querySelector(".year")?.setAttribute("hidden", "true");
                }
                else {
                    thumb.setAttribute("hidden", "true");
                }
            }
        };
        this.filterThumbsByModel = (model) => {
            for (const thumb of this._thumbs) {
                if (thumb.getAttribute("data-model") === model) {
                    thumb.removeAttribute("hidden");
                    thumb.querySelector(".year")?.removeAttribute("hidden");
                }
                else {
                    thumb.setAttribute("hidden", "true");
                }
            }
        };
        this.showAllThumbs = () => {
            for (const thumb of this._thumbs) {
                thumb.removeAttribute("hidden");
                thumb.querySelector(".year")?.removeAttribute("hidden");
            }
        };
        this.showThumbsSection = () => {
            this._thumbsSection.removeAttribute("hidden");
            // There is currently no mechanism to re-show this, so just destroying it.
            this._detailsSection?.remove();
            this._detailsSection = null;
        };
        this._thumbs = document.querySelectorAll("[data-thumbnail]");
        this._vehicleTitle = document.getElementById("vehicleThumbnailsTitle");
        this._thumbsSection = document.getElementById("vehicleThumbnailsSection");
        this._detailsSection = document.getElementById("incentiveDetailsSection");
        this.addEventListeners();
    }
}
selfInstantiateOnLoad(ManufacturerSpecials);
